import { createAndroidEventAsset } from '@/api/advertiser'

export default {
    props: {
        showAndroidEventAssetForm: {
            type: Boolean,
            required: true
        },
        androidEventAssetModel: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            labelCol: { span: 6 },
            wrapperCol: { span: 16 },
            loading: false,
            showSubmit: true,
            rules: {
                track_url_group_name: [
                    { required: true, message: '请输入监测链接组名称', trigger: 'blur' },
                    { max: 50, message: '监测链接组名称最多50个字符', trigger: 'blur' }
                ],
                action_track_url: [
                    { required: true, message: '请输入有效触点监测链接', trigger: 'blur' },
                    { pattern: /^https:\/\/.+/, message: '链接需要以https://开头', trigger: 'blur' }
                ],
            },
            eventOptions: [
                { label: '激活', value: 8 },
                { label: '7日留存', value: 227 },
                { label: '留存天数', value: 393 },
            ],
            result: {
                total: 0,
                task_ids: [],
            },
        }
    },
    computed: {
        model() {
            return this.androidEventAssetModel
        }
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            const data = Object.assign({}, this.model)

            this.result = { total: 0, task_ids: [] }

            this.loading = true
            createAndroidEventAsset(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.result = res.data
                    this.showSubmit = false
                    this.$message.success('任务已提交，请在应用事件任务列表查看执行结果')
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.showSubmit = true
            const hasTask = this.result.task_ids && this.result.task_ids.length > 0
            this.result = { total: 0, task_ids: [] }
            this.$emit('update:showAndroidEventAssetForm', false)
            if (hasTask) {
                this.$emit('success')
            }
        },
    }
}
